import React from "react";

const CtaStyleThree = () => {
  return (
    <section className="cta-style-three">
      <div className="container">
        <div className="row">
          {/* Left Image Section */}
          <div className="col-lg-6 d-flex">
            <div className="my-auto image-block-wrapper text-center">
              <div className="image-block">
                <img
                  src="images/resources/cta-moc-1-1.png" className="d-none d-md-block"
                  alt="Om Sai Cab Service"
                />
              </div>
            </div>
          </div>

          {/* Right Content Section */}
          <div className="col-lg-6">
            <div className="content-block">
              <div className="block-title">
                <div className="dot-line"></div>

                <p>Book your cab anytime with Om Sai Cab Service</p>

                <h2>
                  Safe & Reliable <br />
                  Cab Booking Service
                </h2>
              </div>

              <p>
                Om Sai Cab Service provides comfortable local and outstation
                taxi services with professional drivers, clean vehicles, and
                affordable pricing. Enjoy hassle-free travel with easy booking,
                on-time pickup, and 24/7 customer support for all your travel
                needs.
              </p>

              <div className="button-block">
                {/* Call Button */}
                <a href="tel:+919594849797" className="app-btn apple-btn">
                  <i className="fa fa-phone icon"></i>

                  <span className="text-block">
                    <span className="tag-line">Call Now</span>

                    <span className="store-name">Book Your Cab</span>
                  </span>
                </a>

                {/* Booking Button */}
                <a href="/booking" className="app-btn google-btn">
                  <i className="fa fa-car icon"></i>

                  <span className="text-block">
                    <span className="tag-line">Online Booking</span>

                    <span className="store-name">Book Now</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaStyleThree;